import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const GetBlogPosts = gql`
  query blogposts {
    blogposts {
      id
      title
      description
      content
      perexImage
    }
  }
`;

interface IInputProps {
  children?: any;
  tags: Array<string>;
}

interface IResponse {
  data: any;
}

class BlogQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const blogposts = (this.props as any).blogposts;
    return this.props.children({
      blogposts
    });
  }
}

// # variants(where: { attributeValues_some: { id_in: $filterValues } }) {

export default compose(
  graphql<IInputProps, IResponse>(GetBlogPosts, {
    name: 'blogposts'
  })
)(BlogQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Blog.tsx